export default __webpack_public_path__ + "locales/pl/DataReassignmentDialog.json?hash=f111f0e4f95968a74a139e4ae2353f7f";